import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { Router, NavigationStart,  Event as NavigationEvent } from '@angular/router';
import { UserService, DsconfigService, RestConnService, StorageService, ObservatoryService } from '@services/services.module';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog, MatBottomSheet } from '@angular/material';
import { LoaderViewComponent } from '@components/modal-loader/loader-view/loader-view.component';
import { SessionTimerComponent } from '@components/session-timer/session-timer.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  loggedIn = false;
  private refreshToken: object;
  public contador = 0;
  public contadorLogout = 0;
  public flagContador = false;
  dataSideBarType: string;
  miniSideBar = false;
  miniLogoVisible = false;
  private subscriptions: Array<Subscription> = [];

  constructor(
    private router: Router,
    private dsConfig: DsconfigService,
    private _res: RestConnService,
    private user_service: UserService,
    private storage: StorageService,
    private translate: TranslateService,
    public dialog: MatDialog,
    private observatory: ObservatoryService,
    private _bottomSheet: MatBottomSheet,
  ) {
    // Llamada para obtener token
    this.refreshToken = {
      'refresh_token': dsConfig.getUrlBase() + '/ess/v1/auth/refresh'
    };
    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang('es-ES');

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use('es-ES');

    this.router.events.forEach((event: NavigationEvent) => {
      if (event instanceof NavigationStart) {
        if (!this.user_service.isLogued() || event.url === '/login' || event.url === '/' || (event.url === '/login' && !this.router.navigated) ||  (event.url === '/' && !this.router.navigated)) { //  || !this.router.navigated
          this.loggedIn = false;
        } else {
          this.loggedIn = true;
        }
        this.storage.set('loggedIn', this.loggedIn);
      }

      if (event instanceof NavigationStart) {
        if (this.user_service.isLogued() && !this.router.navigated && !( event.url === '/login' || event.url === '/') ) {
          const count = this.storage.get('countDownSession');
          const countLogin = this.storage.get('countDownLoginSession');
          this.user_service.startCountDown(count);
          this.user_service.startLoginCountDown(countLogin);
        }
      }
    });

  }
  isShow: boolean;
  topPosToStartShowing = 100;

  @HostListener('window:scroll')
  checkScroll() {
    // window의 scroll top
    // Both window.pageYOffset and document.documentElement.scrollTop returns the same result in all the cases. window.pageYOffset is not supported below IE 9.

    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

    if (scrollPosition >= this.topPosToStartShowing) {
      this.isShow = true;
    } else {
      this.isShow = false;
    }
  }

  // TODO: Cross browsing
  gotoTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  refreshCountDownFunction() {
    this.user_service.refreshCountDown();
  }

  toggleMiniSideBarClass() {
    this.miniSideBar = !this.miniSideBar;
  }

  setSidebarType(): void {
    if (window.innerWidth < environment.windowMinWidth) {
      this.dataSideBarType = 'mini-sidebar';
      this.miniLogoVisible = true;
    } else {
      this.dataSideBarType = 'full';
      this.miniLogoVisible = false;
    }
  }

  @HostListener('window:resize')
  onResize() {
    this.setSidebarType();
  }

  ngOnInit() {
    this.user_service.countDownSession$.subscribe(data => {
      if (data === environment.showSessionTimer) {
        this.showSessionTimer();
      }
    });

    setTimeout(() => {
      this.loadObservatoryLoader();
    }, 50);

    this.setSidebarType();
  }

  loadObservatoryLoader(): void {
    this.observatory.getData('loader').subscribe(val => {
      const dialogRef = this.dialog;
      if (val) {
        dialogRef.open(LoaderViewComponent, {
          panelClass: 'transparent',
          disableClose: true
        });

        dialogRef.afterAllClosed.toPromise();
      } else {
        dialogRef.closeAll();
      }
    });
  }

  showSessionTimer() {
    this._bottomSheet.open(SessionTimerComponent, { disableClose: true });
  }

  ngOnDestroy() {
    for (const subs of this.subscriptions) {
      subs.unsubscribe();
    }
  }
}
